

























import {
  defineComponent, ref, computed, PropType,
} from '@vue/composition-api';
import { IconButton } from '@fc/angie-ui';

interface Faq {
  question: string;
  answer: string;
}

export default defineComponent({
  name: 'FCFaqCard',
  components: {
    IconButton,
  },
  props: {
    faq: {
      type: Object as PropType<Faq>,
      required: true,
    },
    codeId: {
      type: String,
      required: true,
    },
  },
  setup() {
    const isActive = ref(false);

    const iconType = computed(() => (isActive.value ? 'times' : 'plus'));

    function toggleCard() {
      isActive.value = !isActive.value;
    }

    return {
      isActive,
      iconType,
      toggleCard,
    };
  },
});
